<script setup lang="ts">
defineProps<{
  value: string | number;
  label: string;
  icon?: string;
  subValue?: string;
  highlight?: boolean;
}>();
</script>

<template>
  <div
    class="card flex items-center gap-4 transition-all hover:shadow-elevated"
    :class="highlight ? 'ring-1 ring-primary/30' : ''"
  >
    <div
      v-if="icon"
      class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-2xl"
      :class="highlight ? 'bg-primary/10' : 'bg-surface-muted'"
    >
      {{ icon }}
    </div>
    <div class="min-w-0 flex-1">
      <div class="truncate text-2xl font-bold tracking-tight" :class="highlight ? 'text-primary' : ''">
        {{ value }}
        <span v-if="subValue" class="ml-1 text-sm font-normal text-ink-muted">{{ subValue }}</span>
      </div>
      <div class="text-xs text-ink-muted">{{ label }}</div>
    </div>
  </div>
</template>
